import Apis from 'apis';
import { objToQueryString } from 'utils/helpers';

export const api = Apis({});

interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
}

export default {
  getCompany: (id: string) => `/company/${id}/`,
  getAllUserCompany: (id: string, query: QueryProps) =>
    `/company/${id}/users/?${objToQueryString(query)}`,
  getAllCompanies: (query: QueryProps) =>
    `/company/?${objToQueryString(query)}`,
  getAllCompaniesOperator: (query: QueryProps) =>
    `/company/summary/?${objToQueryString(query)}`,
  editCompanyNames: (companyUuid: string) => `/company/${companyUuid}/`,
};
